import React, { useState, useContext, memo } from 'react';
import { Handle } from 'react-flow-renderer';

import {
  Typography,
  Grid,
  Button,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Paper,
  TooltipLight,
  Icon,
  IconButton,
  MenuItem,
  ListItemIcon,
  ListItemText,
  ButtonDropdownMenu,
} from 'app/design';
import {
  Delete as DeleteIcon,
  Eject as EjectIcon,
  PresentToAll as PresentToAllIcon,
  FileCopy as FileCopyIcon,
  Phone as PhoneIcon,
  Add as AddIcon,
  Edit as EditIcon,
  MoreHoriz as MoreHorizIcon,
} from 'app/design/icons-material';

import { getAtPath, setAtPath } from 'app/utilities';

import { IvrMenuEventEmitterContext, useSharedFlow } from '../../../../..';

// import { USER_ADDABLE_COMPONENTS } from '../../../../../../Strategies/base/GenericDefault';
// import * as OptionComponents from '../../../../../../Strategies/components';

import { ChooseDialog } from '../../ChooseDialog';

export const MenuItem_AddBefore = props => {
  const { data, mode, onClose } = props;
  const {
    callflow: rootCallflow,
    insertBefore, // bool
    insertAfterData,
    infoIdx,
    currentCallflow,
    componentData,
    componentInfo,
    templateParent,
    // callflow,
    // setCallflow,
    // modifyPath,
  } = data;

  const { callflow, setCallflow, modifyPath } = insertAfterData;

  const [showInsertBefore, setShowInsertBefore] = useState(null);
  const setShowInsertBeforeWrap = setTo => () => setShowInsertBefore(setTo);

  return (
    <>
      {showInsertBefore && (
        <ChooseDialog
          {...insertAfterData}
          requireAllowAfter={true}
          index={insertAfterData.index - 1}
          onClose={setShowInsertBeforeWrap(null)}
        />
      )}
      <MenuItem
        onClick={e => {
          // if (rootCallflow.type != 'template' && templateParent) {
          //   alert(
          //     'Note that adding to this template outside of a Template Endpoint can result in losing information when the Template is re-applied!',
          //   );
          // }
          onClose();
          setShowInsertBefore(true);
        }}
        component={'a'}
      >
        <ListItemIcon>
          <PresentToAllIcon />
        </ListItemIcon>
        <ListItemText primary="Add Before" />
      </MenuItem>
    </>
  );
};

// export const ChooseDialog = (props) => {
//   const {
//     callflow,
//     setCallflow,
//     modifyPath,
//     index,
//     requireAllowBefore, // always false
//     requireAllowAfter,
//     onClose,
//     onAdd, // replaces handleAdd from below!
//   } = props;

//   // modifyPath => to root of callflow!

//   const ee = useContext(IvrMenuEventEmitterContext);

//   // useEffectOnce(() => {
//   //   ee.on('focus-node', focusNode);
//   //   return () => {
//   //     ee.removeListener('focus-node', focusNode);
//   //   };
//   // });

//   // console.log('InsertNode:', data);

//   const handleAdd = (selected) => {
//     // const optKey = selected.value;
//     // const optionComponent = OptionComponents[optKey];

//     // TODO: add "recently added" to the data? or use eventemitter?
//     // - triggers self to run?
//     // - problem if multiple things added??

//     const data = {
//       type: selected.value.type,
//       options: selected.value.options,
//     };

//     // const data = {
//     //   type: 'MenuGreetingAndTargets',
//     // };
//     const components = getAtPath(
//       callflow,
//       `${modifyPath}.strategy.config.components`,
//       []
//     );
//     const stratDataOpts = getAtPath(
//       callflow,
//       `${modifyPath}.strategy.data.opts`,
//       []
//     );
//     // console.log('Adding to index:', index);

//     components.splice(index, 0, data);
//     stratDataOpts.splice(index, 0, {});

//     setAtPath(callflow, `${modifyPath}.strategy.config.components`, components);
//     setAtPath(callflow, `${modifyPath}.strategy.data.opts`, stratDataOpts);

//     // console.log('set after insert:', callflow);

//     setCallflow({ ...callflow }, { name: `Inserted ${selected.value.type}` });

//     // // TODO: focus after rebuild, instead of on a Timeout
//     // window.setTimeout(() => {
//     //   ee.emit('focus-node', {
//     //     key: `${modifyPath}.strategy.config.components[${index}]`,
//     //   });
//     // }, 100);

//     // TODO: focus after rebuild, instead of on a Timeout
//     window.setTimeout(() => {
//       ee.emit('node-created', {
//         key: `${modifyPath}.strategy.config.components[${index}]`,
//         optsPath: `${modifyPath}.strategy.data.opts[${index}]`,
//       });
//     }, 100);
//   };

//   return (
//     <Dialog open onClose={onClose} fullWidth={true} maxWidth="sm">
//       {/* <DialogTitle>Select Option</DialogTitle>
//       <Divider /> */}
//       <DialogContent>
//         <StrategySelect
//           requireAllowBefore={false}
//           requireAllowAfter={requireAllowAfter}
//           onChange={onAdd || handleAdd}
//         />
//       </DialogContent>
//       <Divider />
//       <DialogActions>
//         <Button
//           color="secondary"
//           variant="outlined"
//           onClick={(e) => {
//             onClose();
//           }}
//         >
//           Cancel
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export const StrategySelect = (props) => {
//   const {
//     placeholder,
//     preventComplexBeforeAfter,
//     requireAllowAfter, // determines if the Selectable module is required to have the "allowAfter" value set
//     requireAllowBefore, // determines if the Selectable module is required to have the "allowBefore" value set
//     onChange,
//     selected,
//   } = props;

//   const [anchorEl, setAnchorEl] = useState(null);
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   // TODO: this list of options should be from a different list of possible "before" and "after" possible components
//   // - type, options[props] like in Strategies.componentConfig.components
//   const options = USER_ADDABLE_COMPONENTS.map((component) => {
//     // console.log('optKey:', optKey);
//     const module = OptionComponents[component.type];
//     // console.log('type:', component.type);
//     const allow = requireAllowBefore
//       ? module.allowBefore === true
//         ? true
//         : false
//       : true && requireAllowAfter
//       ? module.allowAfter === true
//         ? true
//         : false
//       : true;
//     return allow ? { ...component, allow: true } : component;
//   }).map((component) => ({
//     label: component.name,
//     value: component,
//     allow: component.allow,
//     type: component.type,
//   }));

//   const opt = null;
//   return (
//     <>
//       {options
//         .filter((opt) => opt.allow)
//         .map((opt) => (
//           <Paper
//             key={opt.label}
//             lcolor={
//               JSON.stringify(opt) === JSON.stringify(selected)
//                 ? 'teal.50'
//                 : 'grey.50'
//             }
//             onClick={() => onChange(opt)}
//             padding={1}
//             style={{ margin: '4px 0' }}
//             elevation={0}
//             elevateOnHover
//           >
//             <Grid container spacing={1} alignItems="center" noWrap>
//               <Grid item>
//                 <Icon style={{ verticalAlign: 'text-top' }} fontSize="small">
//                   {opt.value.icon ?? 'help_outline'}
//                 </Icon>
//               </Grid>
//               <Grid item>
//                 <Typography variant="body2" strong>
//                   {opt.label}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         ))}
//     </>
//   );
// };

export default MenuItem_AddBefore;
